import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ActivedepositPage } from './activedeposit';

@NgModule({
  declarations: [
    ActivedepositPage,
  ],
  imports: [
    IonicPageModule.forChild(ActivedepositPage),
  ],
})
export class ActivedepositPageModule {}



// WEBPACK FOOTER //
// ./src/pages/activedeposit/activedeposit.module.ts